var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z",
    fill: "#392C7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8899 3.45H9.10989C8.70989 3.45 8.38989 3.13 8.38989 2.73C8.38989 2.33 8.70989 2 9.10989 2H14.8899C15.2899 2 15.6099 2.32 15.6099 2.72C15.6099 3.12 15.2899 3.45 14.8899 3.45Z",
    fill: "#392C7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.0001 19.97V17.03C15.0001 15.76 15.7601 15 17.0301 15H19.9701C20.1601 15 20.3301 15.02 20.5001 15.06C20.6101 14.5 20.6701 13.92 20.6701 13.33C20.6701 8.55 16.7801 4.66 12.0001 4.66C7.22008 4.66 3.33008 8.55 3.33008 13.33C3.33008 18.11 7.22008 22 12.0001 22C13.2101 22 14.3601 21.75 15.4101 21.3C15.1501 20.96 15.0001 20.52 15.0001 19.97Z",
    fill: "#392C7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.97 15H17.03C15.76 15 15 15.76 15 17.03V19.97C15 21.24 15.76 22 17.03 22H19.97C21.24 22 22 21.24 22 19.97V17.03C22 15.76 21.24 15 19.97 15ZM19.69 19.46L18.51 20.14C18.27 20.28 18.03 20.35 17.81 20.35C17.64 20.35 17.49 20.31 17.35 20.23C17.03 20.04 16.85 19.67 16.85 19.18V17.82C16.85 17.33 17.03 16.96 17.35 16.77C17.67 16.58 18.08 16.62 18.51 16.86L19.69 17.54C20.11 17.79 20.35 18.13 20.35 18.5C20.35 18.87 20.12 19.21 19.69 19.46Z",
    fill: "#392C7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon-02.023d1600fdebd2a12f83fd8d65837c66.svg";
export { ForwardRef as ReactComponent };